import { CommunicationStateInterface } from "./types";
import Notification from "@/types/app/notifications";
import Schedule from "@/types/app/schedules";

export default {
  
  getModalNewNotificationState(state: CommunicationStateInterface): boolean {
    return state.modalNewNotification;
  },
  getModalNotificationState(state: CommunicationStateInterface): boolean {
    return state.modalNotification;
  },  
  getNotificationState(state: CommunicationStateInterface): Notification {
    return state.notification;
  },
  getNotificationsState(state: CommunicationStateInterface): Notification[] {
    return state.notifications;
  },
  getNotificationSent(state: CommunicationStateInterface): boolean {
    return state.notificationSent;
  }, 
  getModalNotificationDelete(state: CommunicationStateInterface):boolean{
    return state.modalNotificationDelete;
  },
  getScheduleState(state: CommunicationStateInterface): Schedule {
    return state.schedule;
  },
  getModalScheduleState(state: CommunicationStateInterface): boolean {
    return state.modalSchedule;
  },
  getScheduleFeedbackModalState(state: CommunicationStateInterface): boolean {
    return state.scheduleFeedbackModal;
  },
  getModalNewEmailNotificationState(state: CommunicationStateInterface): boolean {
    return state.modalNewEmailNotification;
  },
  getModalEmailNotificationState(state: CommunicationStateInterface): boolean {
    return state.modalEmailNotification;
  },
  getEmailNotificationState(state: CommunicationStateInterface): Notification {
    return state.emailNotification;
  },
  getEmailNotificationsState(state: CommunicationStateInterface): Notification[] {
    return state.emailNotifications;
  },
  getEmailNotificationSent(state: CommunicationStateInterface): boolean {
    return state.emailNotificationSent;
  },
  getModalEmailNotificationDelete(state: CommunicationStateInterface): boolean {
    return state.modalEmailNotificationDelete;
  },

};
